import React from 'react';
import PropTypes from 'prop-types';
import CCIcon from './CCIcon';

const CCButton = ({
  type,
  nativeType,
  size,
  iconSize,
  iconColor,
  label,
  icon,
  iconPosition,
  children,
  disabled,
  ...rest
}) => {
  const renderIconByPosition = (position) => (
    icon && iconPosition === position
      ? (
        <CCIcon
          size={iconSize}
          color={iconColor}
        >{icon}
        </CCIcon>
      )
      : null
  );

  return (
  // eslint-disable-next-line react/button-has-type
    <button
      {...rest}
      type={nativeType || 'button'}
      className={`btn btn-${type} btn-${size} ${icon ? 'btn-with-icon' : ''} ${rest.className || ''}`}
      disabled={disabled}
    >
      {renderIconByPosition('left')}
      {label || children}
      {renderIconByPosition('right')}
      {
        rest.className && rest.className.includes('btn-loading')
          ? (
            <img
              src={`${process.env.PUBLIC_URL}/images/loading-indicator.svg`}
              className="loader"
              alt="loader"
            />
          )
          : null
      }
    </button>
  );
};

CCButton.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  nativeType: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
  iconPosition: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  disabled: PropTypes.bool,
};

CCButton.defaultProps = {
  type: 'primary',
  size: 'xs',
  nativeType: 'button',
  icon: '',
  iconColor: 'white',
  iconSize: 20,
  iconPosition: 'right',
  label: '',
  disabled: false,
  children: <div />,
};

export default CCButton;
